import * as React from 'react';
import { Button, Intent, Popover, PopoverInteractionKind, H5, Classes } from '@blueprintjs/core';
import { AddButton } from '../AddButton';
import { StandardInput } from '../StandardInput';
import { executeQueryPostAuth, executeQueryPost } from 'app/utils/api';
import { UserState } from 'app/reducers/state';

const TRANSACTION_ID_FOR_PAID_USER = "8LKGQYDQF3LJDH";

interface Props {
    user: UserState;
    onSaved: () => void;
    onSaving: () => void;
};

interface State {
    _email: string;
    _first: string;
    _last: string;
    _password: string;
    _class: string;
}

export class AddUser extends React.Component<Props, State> {

    state: State = {
        _email: '',
        _first: '',
        _last: '',
        _password: '',
        _class: ''
    }

	render() {
        const {
            _email,
            _first,
            _last,
            _password,
            _class
        } = this.state;

        return <Popover
            canEscapeKeyClose={true}
            interactionKind={PopoverInteractionKind.CLICK}
        >
           <AddButton label="New Professor" />
            <div key="text" style={{display: 'block', padding: '20px', marginBottom: '20px'}}>
                <H5>New Professor</H5>
                <p>
                    <StandardInput 
                        autoFocus={true}
                        onChange={(value) => { this.setState({_email: value.target.value}); }}
                        type={"text"}
                        value={_email}
                        label={"Email"} />
                    <StandardInput 
                        autoFocus={false}
                        onChange={(value) => { this.setState({_first: value.target.value}); }}
                        type={"text"}
                        value={_first}
                        label={"First Name"} />
                    <StandardInput 
                        autoFocus={false}
                        onChange={(value) => { this.setState({_last: value.target.value}); }}
                        type={"text"}
                        value={_last}
                        label={"Last Name"} />
                    <StandardInput 
                        autoFocus={false}
                        onChange={(value) => { this.setState({_password: value.target.value}); }}
                        type={"text"}
                        value={_password}
                        label={"Password"} />
                    <StandardInput 
                        autoFocus={false}
                        onChange={(value) => { this.setState({_class: value.target.value}); }}
                        type={"text"}
                        value={_class}
                        label={"Class ID"} />
                </p>
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                    <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>
                        Cancel
                    </Button>
                    <Button intent={Intent.PRIMARY} className={Classes.POPOVER_DISMISS} onClick={() => {
                        this.props.onSaving();

                        // First save the actual user
                        executeQueryPostAuth("users", {
                            email: _email,
                            password: _password,
                            first: _first,
                            last: _last
                        }, this.props.user, () => {
                            // Now grab the user's authentication token
                            executeQueryPost("users/token", {
                                email: _email,
                                password: _password
                            }, (tokenResponse) => {
                                const tokenResponseData = tokenResponse.body;
                                const userID = tokenResponseData.id;

                                // Now set the user to be a professor
                                executeQueryPostAuth("users/" + userID + "/level", { level: "2" }, this.props.user, () => {
                                    // Now enroll them in the given class
                                    executeQueryPostAuth("class/enrollment", {user: userID, class: _class}, this.props.user, () => {
                                        // Finally set them to paid
                                        executeQueryPostAuth("transactions/own", {user: userID, transaction: TRANSACTION_ID_FOR_PAID_USER}, this.props.user, () => {
                                            this.props.onSaved();
                                        });
                                    });
                                });
                            });
                        });                        
                    }}>
                        Save
                    </Button>
                </div>
            </div>
        </Popover>
	}
}
